import Image from '@anm/components/image/Image';
import { PASSWORD_CHECK_LIST } from '@anm/data/passwordChecklist';
import { Row } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

const StyledRow = styled(Row)`
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin-bottom: 25px;
`;

const WrapperImage = styled(Image)`
  margin-right: 13.5px;
  width: 17px;
  height: 17px;
`;

const Content = styled.div`
  padding: 30px 20px;
  min-width: 240px;
  ${StyledRow}:last-child {
    margin: 0;
  }
`;

type ChecklistProps = { newPassword: string };

const PasswordCheckList: FC<ChecklistProps> = ({ newPassword }) => (
  <Content>
    {PASSWORD_CHECK_LIST.map(({ label, pattern }) => {
      const isValid = pattern.test(newPassword);
      const val = isValid ? 'success' : 'error';

      return (
        <StyledRow key={label}>
          <WrapperImage src={`images/icons/validation_${val}.svg`} />
          <span>{label}</span>
        </StyledRow>
      );
    })}
  </Content>
);

export default PasswordCheckList;
